import React from 'react';
import { Calendar, Filter, X, Users, AlertCircle, Activity } from 'lucide-react';
import Icon from '../../../components/AppIcon';


export default function FilterSidebar({ 
  filters, 
  users, 
  onFilterChange, 
  onApplyFilters, 
  onClearFilters 
}) {
  const eventTypes = [
    { value: 'all', label: 'All Events', icon: Activity },
    { value: 'admin_actions', label: 'Admin Actions', icon: Users },
    { value: '2fa_events', label: '2FA Events', icon: AlertCircle },
    { value: 'permission_changes', label: 'Permission Changes', icon: Users },
    { value: 'system_activities', label: 'System Activities', icon: Activity }
  ];

  const severityLevels = [
    { value: '', label: 'All Levels' },
    { value: 'info', label: 'Info', color: 'text-blue-600' },
    { value: 'warning', label: 'Warning', color: 'text-yellow-600' },
    { value: 'error', label: 'Error', color: 'text-orange-600' },
    { value: 'critical', label: 'Critical', color: 'text-red-600' }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <Filter className="w-5 h-5 text-green-600" />
          Filters
        </h2>
        <button
          onClick={onClearFilters}
          className="text-sm text-gray-600 hover:text-gray-900 flex items-center gap-1"
        >
          <X className="w-4 h-4" />
          Clear
        </button>
      </div>
      <div className="space-y-6">
        {/* Date Range */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
            <Calendar className="w-4 h-4" />
            Date Range
          </label>
          <div className="space-y-3">
            <input
              type="date"
              value={filters?.startDate}
              onChange={(e) => onFilterChange('startDate', e?.target?.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
              placeholder="Start date"
            />
            <input
              type="date"
              value={filters?.endDate}
              onChange={(e) => onFilterChange('endDate', e?.target?.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
              placeholder="End date"
            />
          </div>
        </div>

        {/* Event Type */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Event Type
          </label>
          <div className="space-y-2">
            {eventTypes?.map((type) => {
              const Icon = type?.icon;
              return (
                <label
                  key={type?.value}
                  className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
                >
                  <input
                    type="radio"
                    name="eventType"
                    value={type?.value}
                    checked={filters?.eventType === type?.value}
                    onChange={(e) => onFilterChange('eventType', e?.target?.value)}
                    className="w-4 h-4 text-green-600 focus:ring-green-500"
                  />
                  <Icon className="w-4 h-4 text-gray-400" />
                  <span className="text-sm text-gray-700">{type?.label}</span>
                </label>
              );
            })}
          </div>
        </div>

        {/* Severity Level */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
            <AlertCircle className="w-4 h-4" />
            Severity Level
          </label>
          <select
            value={filters?.severity}
            onChange={(e) => onFilterChange('severity', e?.target?.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          >
            {severityLevels?.map((level) => (
              <option key={level?.value} value={level?.value}>
                {level?.label}
              </option>
            ))}
          </select>
        </div>

        {/* User Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
            <Users className="w-4 h-4" />
            User
          </label>
          <select
            value={filters?.userId}
            onChange={(e) => onFilterChange('userId', e?.target?.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          >
            <option value="">All Users</option>
            {users?.map((user) => (
              <option key={user?.id} value={user?.id}>
                {user?.full_name} ({user?.role})
              </option>
            ))}
          </select>
        </div>

        {/* Apply Button */}
        <button
          onClick={onApplyFilters}
          className="w-full px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium"
        >
          Apply Filters
        </button>
      </div>
    </div>
  );
}